import PropTypes from "prop-types";
import React from "react";
import Modal from "react-modal";
import { screenSize, values } from "../../globals";
import "../../styles/ModalStyles.scss";
import STSComponent from "../STSComponent/STSComponent";

class CustomModal extends STSComponent {
  commonModalStyles = (top, zIndex) => {
    return {
      overlay: {
        position: "fixed",
        top: top,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        display: "flex",
        justifyContent: "left",
        alignItems: "last baseline",
        zIndex: zIndex,
        height: "2000px",
        padding: "50px",
      },
      content: {
        top:
          window.innerWidth <= screenSize.specialSize
            ? values.paddingTablets
            : values.paddingDesktop,
        left: window.innerWidth <= screenSize.specialSize ? 10 : "auto",
        right: window.innerWidth <= screenSize.specialSize ? 10 : "auto",
        bottom: "auto",
        maxWidth:
          window.innerWidth <= screenSize.specialSize
            ? "auto"
            : values.widthSubj,
        marginRight: 0,
        background: "rgb(35,62,102)",
        padding: 0,
        border: 0,
        borderRadius: 0,
        boxShadow: "0px 0px 20px 3px rgba(0,0,0,0.8)",
        textAlign: "center",
        fontWeight: 300,
        color: "#fff",
        fontSize: 18,
        textTransform: "uppercase",
        letterSpacing: 2,
      },
    };
  };

  render() {
    const {
      children,
      modal,
      contentLabel,
      customStyles,
      modalType,
      zIndex = 95,
    } = this.props;
    const commonStyles = this.commonModalStyles(window.scrollY, zIndex);
    const renderStyles = {
      ...customStyles,
      overlay: {
        ...commonStyles.overlay,
        ...customStyles.overlay,
      },
      content: {
        ...commonStyles.content,
        ...customStyles.content,
      },
    };
    return (
      <Modal
        isOpen={
          modal[modalType] &&
          modal[modalType].modalType === modalType &&
          modal[modalType].isModalOpen
        }
        contentLabel={contentLabel}
        style={renderStyles}
        ariaHideApp={false}
      >
        {children}
      </Modal>
    );
  }

  static propTypes = {
    modalType: PropTypes.string.isRequired,
    contentLabel: PropTypes.string.isRequired,
    customStyles: PropTypes.object,
    modal: PropTypes.object.isRequired,
    children: PropTypes.node,
    zIndex: PropTypes.number,
  };
}

export default CustomModal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js